import React from 'react';
import { ReactComponent as ErrorInfoIcon } from '../../../../assets/svg/signup/error-info-icon.svg';
import { AUTH_STRINGS } from '../../../../constants/strings';

/**
 * Props definition for FieldErrorMessageRender component.
 *
 * @property {any} error - The error object typically returned from a form validation library (e.g., React Hook Form).
 * @property {string} fieldKey - The specific key in the error object representing the field to validate.
 */
interface RequiredFieldErrorProps {
  error: any;
  fieldKey: string;
  type?:'date'
}

interface InputErrType {
  type: string;
  message: string;
}

/**
 * function throw error message based on the error type.
 */
const getValidateErrorByField = (type?: string,errMsg?:string): React.ReactNode => {
  switch (type) {
    case 'date':
        return errMsg;
    default:
      return errMsg || 'INVALID';
  }
};

/**
 * Function to check error type is required and return message "Please complete this field"
 * @param err 
 * @returns 
 */
const getErrorMessageByType = ( err: InputErrType | undefined,type?: string): React.ReactNode => {
  if (!err) return null;

  switch (err.type) {
    case 'manual':
      return err.message;
    case 'min':
      return err?.message || AUTH_STRINGS.ERRORS.MIN_PERCENTAGE;
    case 'max':
      return err?.message || AUTH_STRINGS.ERRORS.MAX_PERCENTAGE;
    case 'validate':
      return getValidateErrorByField(type,err.message);
    case 'minLength':
      return err.message;
    case 'maxLength':
      return err.message;
    case 'required':
      return AUTH_STRINGS.ERRORS.REQUIRED;
    case 'pattern':
      return err.message;
    case 'complete':
      return AUTH_STRINGS.ERRORS.LEFT_SIDEBAR_COMPLETE;
    default:
      return null;
  }
};
/**
 * Author : SHIVARAJ PP
 * Component Name : FieldErrorMessageRender

/**
 * FieldErrorMessageRender is a reusable component used to render
 * a styled validation error message for required form fields
 */
export const FieldErrorMessageRender: React.FC<RequiredFieldErrorProps> = ({ error, fieldKey,type }) => {
  const message = error && getErrorMessageByType(error[fieldKey],type);
  if (!message || message.length === 0) return null;

  return (
    <div className="error-container">
      <div className="error-icon">
        <ErrorInfoIcon />
      </div>
      <div className="error-message">
        {message}
      </div>
    </div>
  );
};